var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    { staticClass: "alert-triage" },
    [
      _c(
        "div",
        { staticClass: "alert-triage__header" },
        [
          _c("h3", { staticClass: "alert-triage__title" }, [
            _vm._v("Your alert triage"),
          ]),
          _vm._v(" "),
          _c(
            "nuxt-link",
            {
              staticClass: "alert-triage__personalise",
              attrs: { to: "/profile/my-watchlist" },
            },
            [_vm._v("\n      Personalise your alerts\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "alert-triage__subtitle" }, [
        _vm._v("Updates for you to review"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "alert-triage__list" },
        [
          _vm._l(_vm.alerts, function (alert, index) {
            return _c("div", { key: index, staticClass: "triage-card" }, [
              _c("h4", { staticClass: "triage-card__title" }, [
                _vm._v(_vm._s(alert.title)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "triage-card__row" }, [
                _c("div", { staticClass: "triage-card__indicators" }, [
                  _c(
                    "span",
                    {
                      staticClass: "triage-card__badge",
                      class: `triage-card__badge--${alert.classification}`,
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.formatClassification(alert.classification)
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "triage-card__score" }, [
                    _vm._v("p " + _vm._s(alert.priority)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "triage-card__score" }, [
                    _vm._v("r " + _vm._s(alert.recency)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "triage-card__actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "triage-card__btn triage-card__btn--dismiss",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("dismiss", index)
                        },
                      },
                    },
                    [_vm._v("\n            Dismiss\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "triage-card__btn triage-card__btn--action",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("action", index)
                        },
                      },
                    },
                    [_vm._v("\n            Action\n          ")]
                  ),
                ]),
              ]),
            ])
          }),
          _vm._v(" "),
          !_vm.alerts.length
            ? _c("div", { staticClass: "alert-triage__empty" }, [
                _vm._v("\n      No alerts to review.\n    "),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.alerts.length
        ? _c(
            "nuxt-link",
            {
              staticClass: "alert-triage__see-all",
              attrs: { to: "/regulatory_updates" },
            },
            [
              _vm._v("\n    See all alerts\n    "),
              _c(
                "svg",
                {
                  attrs: {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 14 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M5 3l4 4-4 4",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }